var _line, _path, _line2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncognitoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 13.25,
    x2: 21,
    y2: 13.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.00001L5 13L19 13L15.5 4L12.666 6.53034C12.2866 6.86909 11.7134 6.86909 11.334 6.53034L8.5 4.00001Z",
    fill: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16.7003,
    x2: 20,
    y2: 16.7003,
    stroke: "white",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 17.2002C4.6 16.9793 4.77909 16.8002 5 16.8002H10.5894C10.865 16.8002 11.0581 17.0725 10.9668 17.3326L10.5699 18.4637C10.3731 19.0247 9.8434 19.4002 9.24888 19.4002H6C5.2268 19.4002 4.6 18.7734 4.6 18.0002V17.2002Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0332 17.3326C12.9419 17.0725 13.135 16.8002 13.4106 16.8002H19C19.2209 16.8002 19.4 16.9793 19.4 17.2002V18.0002C19.4 18.7734 18.7732 19.4002 18 19.4002H14.7511C14.1566 19.4002 13.6269 19.0247 13.4301 18.4637L13.0332 17.3326Z",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncognitoIcon);
export default __webpack_public_path__ + "static/media/incognito-icon.659b79c600af1e63bab17d1e441f9722.svg";
export { ForwardRef as ReactComponent };